module.exports = __webpack_public_path__ + "img/sidebar-close.f500e49d.svg";